import { render, staticRenderFns } from "./RegistrationDetail.vue?vue&type=template&id=19e3737b&scoped=true&"
import script from "./RegistrationDetail.vue?vue&type=script&lang=js&"
export * from "./RegistrationDetail.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationDetail.vue?vue&type=style&index=0&id=19e3737b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e3737b",
  null
  
)

export default component.exports